/* Galaxy Lighting - collection card badges.

   WHAT THIS FIXES
   Dawn's card renders ONE badge slot. When a product is out of stock it puts
   "Sold out" there and the TRADE badge is never emitted - even though the trade
   price itself still applies (the card shows e.g. $269.00 struck through and
   $215.20 as the sale price, and carries .price--galaxy-trade).

   Sold-out products must show BOTH badges: the red SOLD OUT tag and the gold
   TRADE tag. So for any card that has a trade price but no trade badge, we
   compute the percentage from the rendered prices and append the badge, matching
   the markup Liquid produces on in-stock cards exactly:

     <span class="badge badge--bottom-left galaxy-trade-badge">TRADE - N% OFF</span>

   Colours and stacking are pure CSS (galaxy-collection-wide.css sections 6/6b/6c):
   gold trade tag, deep-red sold-out tag, stacked top-left of the image.

   HISTORY (2026-07-28): this file was accidentally overwritten during the
   sticky-header work, and two attempts to reconstruct it made things worse -
   first injecting a duplicate "-N%" tag alongside the existing TRADE tag, then
   stripping it back to a no-op, which is what removed the TRADE badge from
   sold-out cards. This version restores the intended behaviour: add the trade
   badge only where Liquid omitted it, never duplicate one that already exists.

   Re-runs after infinite scroll appends more cards.
*/
(function () {
  if (window.__gxBadges) return;
  window.__gxBadges = true;

  function money(el) {
    if (!el) return null;
    var n = parseFloat((el.textContent || '').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : n;
  }

  function tagCard(card) {
    if (card.__gxDone) return;
    card.__gxDone = true;

    /* Only cards that actually carry a trade price. */
    if (!card.querySelector('.price--galaxy-trade')) return;

    /* Liquid already rendered the badge (in-stock case) - leave it alone. */
    if (card.querySelector('.galaxy-trade-badge')) return;

    var box = card.querySelector('.card__inner .card__badge') || card.querySelector('.card__badge');
    if (!box) return;

    var reg = money(card.querySelector('.price-item--regular'));
    var sale = money(card.querySelector('.price-item--sale'));
    if (reg === null || sale === null || reg <= 0 || sale >= reg) return;

    var pct = Math.round((1 - sale / reg) * 100);
    if (pct < 1) return;

    var b = document.createElement('span');
    b.className = 'badge badge--bottom-left galaxy-trade-badge';
    b.textContent = 'TRADE · ' + pct + '% OFF';
    box.appendChild(b);
  }

  function run() {
    var cards = document.querySelectorAll('.card-wrapper');
    for (var i = 0; i < cards.length; i++) tagCard(cards[i]);
  }

  function boot() {
    run();
    var grid = document.getElementById('product-grid');
    if (grid && !grid.__gxBadgeObs) {
      grid.__gxBadgeObs = true;
      new MutationObserver(function () { run(); }).observe(grid, { childList: true });
    }
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
